export default "__VITE_ASSET__B$JHJbBK__"